export default "__VITE_ASSET__ccae0c98__"